export const chatBotMessageRef = 'chat-bot-messaging';
